import { NameAndCode } from '@/fetching/sharedSchemas/basicSchemas';

/** @deprecated Use Language imported from 'gql-types' */
export enum Language {
    ENGLISH = 'ENGLISH',
    SPANISH = 'SPANISH',
    KHMER = 'KHMER',
    VIETNAMESE = 'VIETNAMESE',
    CHINESE = 'CHINESE',
    FRENCH = 'FRENCH',
    ARABIC = 'ARABIC',
    PERSIAN = 'PERSIAN',
    TAGALOG = 'TAGALOG',
    URDU = 'URDU',
    KOREAN = 'KOREAN',
    RUSSIAN = 'RUSSIAN',
    GERMAN = 'GERMAN',
    HEBREW = 'HEBREW',
    PORTUGUESE = 'PORTUGUESE',
    ASL = 'ASL',
}

export const renderLanguage = (language: Language): string => {
    switch (language) {
        case Language.ENGLISH:
            return 'English';
        case Language.SPANISH:
            return 'Spanish';
        case Language.KHMER:
            return 'Khmer';
        case Language.VIETNAMESE:
            return 'Vietnamese';
        case Language.CHINESE:
            return 'Chinese';
        case Language.FRENCH:
            return 'French';
        case Language.ARABIC:
            return 'Arabic';
        case Language.PERSIAN:
            return 'Persian';
        case Language.TAGALOG:
            return 'Tagalog';
        case Language.URDU:
            return 'Urdu';
        case Language.KOREAN:
            return 'Korean';
        case Language.RUSSIAN:
            return 'Russian';
        case Language.GERMAN:
            return 'German';
        case Language.HEBREW:
            return 'Hebrew';
        case Language.PORTUGUESE:
            return 'Portuguese';
        case Language.ASL:
            return 'American Sign Language';
        default:
            // Degrade to the raw value rather than throwing: an unmapped language
            // (e.g. a backend enum the frontend's schema package predates) should
            // render its code, not crash the clinician header / anywhere else.
            return language;
    }
};

// Temp: conversion between graphql and zod types
export const languageToCode = (language: Language): string => {
    switch (language) {
        case Language.ENGLISH:
            return 'en';
        case Language.SPANISH:
            return 'es';
        case Language.KHMER:
            return 'km';
        case Language.VIETNAMESE:
            return 'vi';
        case Language.CHINESE:
            return 'zh';
        case Language.FRENCH:
            return 'fr';
        case Language.ARABIC:
            return 'ar';
        case Language.PERSIAN:
            return 'fa';
        case Language.TAGALOG:
            return 'tl';
        case Language.URDU:
            return 'ur';
        case Language.KOREAN:
            return 'ko';
        case Language.RUSSIAN:
            return 'ru';
        case Language.GERMAN:
            return 'de';
        case Language.HEBREW:
            return 'he';
        case Language.PORTUGUESE:
            return 'pt';
        case Language.ASL:
            return 'ase';
        default:
            throw new Error(`Unknown language: ${language as string}`);
    }
};
export const codeToLanguage = (code: string): Language => {
    switch (code) {
        case 'en':
            return Language.ENGLISH;
        case 'es':
            return Language.SPANISH;
        case 'km':
            return Language.KHMER;
        case 'vi':
            return Language.VIETNAMESE;
        case 'zh':
            return Language.CHINESE;
        case 'fr':
            return Language.FRENCH;
        case 'ar':
            return Language.ARABIC;
        case 'fa':
            return Language.PERSIAN;
        case 'tl':
            return Language.TAGALOG;
        case 'ur':
            return Language.URDU;
        case 'ko':
            return Language.KOREAN;
        case 'ru':
            return Language.RUSSIAN;
        case 'de':
            return Language.GERMAN;
        case 'he':
            return Language.HEBREW;
        case 'pt':
            return Language.PORTUGUESE;
        case 'ase':
            return Language.ASL;
        default:
            throw new Error(`Unknown language code: ${code}`);
    }
};

// Temp: conversion between graphql and zod types
export const languageToZod = (language: Language): NameAndCode => {
    return { code: languageToCode(language), name: renderLanguage(language) };
};

export const availableLanguages = Object.values(Language).map(languageToZod);
